import type { VideoData } from "@/shared/interfaces/VideoData";
import { downloadCombinedTranscript } from "@/shared/api/transcriptDownloadApi";

export function hasAnyTranscript(
  videos: VideoData[] | null | undefined,
): boolean {
  if (!videos) return false;
  return videos.some((v) => !!v?.transcript);
}

/**
 * Downloads a single combined transcript (TXT) for the given videos, generated
 * server-side. The native-language sentinel downloads the stored transcripts;
 * any other language is translated server-side. Only videos that have a
 * transcript are included, and their order is preserved. Errors propagate to the
 * caller.
 */
export async function downloadCombinedTranscriptInLanguage(
  videos: VideoData[] | null | undefined,
  filenameBase: string,
  languageCode: string,
): Promise<void> {
  if (!videos) return;
  const evidenceIds = videos.filter((v) => v?.transcript).map((v) => v.id);
  if (evidenceIds.length === 0) return;
  await downloadCombinedTranscript({ evidenceIds, languageCode, filenameBase });
}
